const mapSupportPage = (data) => {
  const { customerRelationsTeam, faqs } = data;
  return {
    customerRelationsTeam,
    faqs
  };
};

export default mapSupportPage;
